const expandingForm = () => {
  const form = document.querySelector(".js-expanding-form");
  const formInner = document.querySelector(".js-expanding-form-inner");
  const formBtn = document.querySelector(".js-expanding-form-btn");
  const formBtnBox = document.querySelector(".js-expanding-form-btn-box");

  if (!form) return;

  let expanded = false;

  formBtn.addEventListener("click", () => {
    if (expanded) return;
    expanded = true;
    formBtnBox.style.height = 0;
    form.style.height = formInner.getBoundingClientRect().height + "px";
    setTimeout(() => {
      form.style.overflow = "visible";
      form.style.height = "auto";
    }, 500);
  });
};

export default expandingForm;
